// extracted by mini-css-extract-plugin
export default {"card":"servicesCard_card__0rqOH","title":"servicesCard_title__q6vaM","text":"servicesCard_text__NICdX"};